import { styled, Typography, TypographyProps } from "@mui/material";

interface CellTextProps extends TypographyProps {
  /**
   * If true, text will truncate with ellipsis when it overflows.
   * If false, text will wrap normally.
   * @default true
   */
  noWrap?: boolean;
}

/**
 * Nicely align a cells text in OmnisearchDataGrid
 */
export const CellText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "noWrap",
})<CellTextProps>(({ theme, noWrap = true }) => ({
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  alignItems: "start",
  height: "100%",
  ...(noWrap && {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  }),
}));
